import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const ClubSkeleton: React.FC = () => {
  return (
    <div className="overflow-hidden rounded-[14px] border border-gc-line bg-white shadow-[0_1px_2px_rgba(11,18,32,0.04)]">
      <Skeleton className="h-[3px] w-full rounded-none" />

      {/* Header: thumbnail + identity + actions */}
      <div className="flex items-start gap-3 px-4 pt-[15px]">
        <Skeleton className="h-[48px] w-[48px] rounded-[11px] shrink-0" />
        <div className="flex flex-1 flex-col gap-2 min-w-0">
          <Skeleton className="h-[15px] w-[150px]" />
          <Skeleton className="h-[12px] w-[110px]" />
        </div>
        <Skeleton className="h-[24px] w-[90px] rounded-full shrink-0" />
      </div>

      {/* Metric tiles */}
      <div className="grid grid-cols-1 gap-3 px-4 py-[14px] sm:grid-cols-2 lg:grid-cols-3">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="flex flex-col overflow-hidden rounded-[12px] border border-gc-line"
          >
            <div className="flex flex-col gap-3 bg-[#FCFDFE] p-[13px]">
              <Skeleton className="h-[22px] w-[70px]" />
              <Skeleton className="h-[20px] w-[90px] rounded-full" />
            </div>
            <Skeleton className="h-11 w-full rounded-none border-t border-[#E6EBF1]" />
          </div>
        ))}
      </div>
    </div>
  );
};
